import '@adornis/bh-video-conferencing/api/index.js';
import '@adornis/bh-timeframes/api/index.js';
import './AdminInstitutionViewSetting.js';
import './booking.js';
import './bundle.js';
import './category.js';
import './counseling.js';
import './global-notification.js';
import './global-settings.js';
import './institution-dashboard.js';
import './institution-whatsapp.js';
import './lecturer-data.js';
import './lecturer.js';
import './mail.js';
import './multiCertificate.js';
import './payment.js';
import './product-entry-requirement.js';
import './product.js';
import './recommendations.js';
import './stammdaten.js';
import './statistic.js';
import './suspension.js';
import './teaching.js';
import './user-data.js';
import './users.js';
import './workshop-set.js';
import './workshop.js';
import './BuildifyContent.js';
import './ParticipationEinzelberatung.js';
import './ParticipationsDataview.js';
import './RegistrationConfirmationCode.js';
import './certificate.js';
import './einzelberatung.js';
import './export-participations.js';
import './institutionLegalDoc.js';
import './lecturerComments.js';
import './mail-templates.js';
import './participation-helper.js';
import './participation.js';
import './product-waitinglist-priority-rule.js';
import './settings.js';
import './institution.js';
import './lecturer-contract.js';
import './action.js';
import './files.js';
import './certificate-workshop-set.js';
import './workshop-document.js';
import './ParticipationWorkshop.js';
